import styled from 'styled-components'
import { ReactComponent as MetamaskFoxSvg } from '../../assets/images/metamask-fox.svg'

export const MetamaskFox = styled(MetamaskFoxSvg)<{ size: number }>`
    width: ${(props) => props.size}px;
    height: ${(props) => props.size}px;
`
